<template>
  <base-dialog
    :title="'room.param.height.title' | i18n"
    :subtitle="'room.param.height.subtitle' | i18n"
    :description="'room.param.height.description' | i18n">
    <div class="container-fluid" style="padding: 0;">
      <div class="row">
        <div class="col-4">
          <img src="../../assets/param/common_height.png" />
        </div>

        <div class="col-8">
          <label>Huonekorkeus (1,90 - 3,50 m)</label>
          <input-number v-model="height" :decimals="2" :min="1.9" :max="3.5" />
        </div>
      </div>
    </div>
  </base-dialog>
</template>


<script>
  import Vue from 'vue'
  import BaseDialog from "./BaseDialog"
  import townService from "../../api/townService";
  import { mapState } from 'vuex'

  export default {
    computed: {
      height: {
        get() {
          return this.$store.state.roomParams.height
        },
        set(height) {
          this.$store.commit('roomParams/SET_HEIGHT', height)
        }
      }
    },

    created() {
      if(this.height == null) {
        this.height = 2.5
      }
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  img {
    max-width: 100%;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/RoomHeightDialog.vue